import { useParams } from "react-router-dom";
import AllTempBillingReconciliations from "../../components/temp-billing-reconciliation";
import ReconciliationDetail from "../../components/temp-billing-reconciliation/ReconciliationDetail";

// kan-101. Both reconciliation routes land here: the bare route lists the
// payments, `/:paymentMetaId` reconciles one of them.
const TempBillingReconciliation = () => {
  const { paymentMetaId } = useParams<{ paymentMetaId?: string }>()

  return paymentMetaId
    ? <ReconciliationDetail paymentMetaId={paymentMetaId} />
    : <AllTempBillingReconciliations />
}

export default TempBillingReconciliation;
